import { notify } from "@kyvg/vue3-notification";
import { useToast } from 'vue-toastification'
const toast = useToast()
const state = {
  prescriptionSaleCartItems:[],
  prescriptionSaleCartInfo:{}, 
  countPrescriptionSaleCartItems: 0, 
  hold_prescription_sale_info:{},
  edit_prescription_sale_info:'',
  prescription_sale_id:'',
}

const mutations = {
  UPDATE_PRES_SALE_CART_ITEMS (state, payload) {  
    const cartItemProduct = JSON.stringify(payload);  
    const itemProduct = JSON.parse(cartItemProduct);  
    const newCartProduct = {
      product_id: itemProduct.product_id,
      product_stock_id: itemProduct.product_stock_id,
      product_name: itemProduct.product_name, 
      mrp_price: itemProduct.mrp_price,
      product_code: itemProduct.product_code,
      discount: itemProduct.discount,
      item_discount: itemProduct.item_discount,
      tax: itemProduct.tax,
      expires_date: itemProduct.expires_date,
      quantity: itemProduct.min_order_qty ? itemProduct.min_order_qty : 1,
      stock_quantity: itemProduct.stock_quantity,
      weight: itemProduct.weight,
      measuring_unit: itemProduct.measuring_unit,
      min_order_qty:itemProduct.min_order_qty, 
      uom:itemProduct.measuring_unit,
      dis_array:itemProduct.dis_array, 
    }; 
    const cartProducts =  state.prescriptionSaleCartItems;
    let cartProductExists = false;
    cartProducts.map((cartProduct) => {
      if((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_stock_id === newCartProduct.product_stock_id)){
        cartProduct.quantity++;
        cartProductExists = true;
      }
    });
    if (!cartProductExists) cartProducts.push(newCartProduct);     
  },
  UPDATE_PRES_SALE_HOLD_ITEMS (state, payload) {  
    const cartItemProduct = JSON.stringify(payload);  
    const itemProduct = JSON.parse(cartItemProduct); 
    const newCartProduct = {
      product_id: itemProduct.product_id,
      product_stock_id: itemProduct.product_stock_id,
      product_name: itemProduct.product_name, 
      mrp_price: itemProduct.mrp_price,
      product_code: itemProduct.product_code,
      discount: itemProduct.discount,
      item_discount: itemProduct.item_discount,
      discount_percent: itemProduct.discount_percent,
      tax: itemProduct.tax,
      expires_date: itemProduct.expires_date,
      quantity: Number(itemProduct.quantity)
    }; 
    const cartProducts =  state.prescriptionSaleCartItems;
    let cartProductExists = false;
    cartProducts.map((cartProduct) => {
      if((cartProduct.product_id === newCartProduct.product_id) && (cartProduct.product_stock_id === newCartProduct.product_stock_id)){
        cartProduct.quantity++;
        cartProductExists = true;
      }
    });
    if (!cartProductExists) cartProducts.push(newCartProduct);     
  },
  SELECT_PRES_SALE_CARTINFO (state, payload) { 
    Object.assign(state.cartInfo, payload);
  },
  removePresSaleAllFromcart: (state) =>{  
    state.prescriptionSaleCartItems.splice(0);
    state.hold_prescription_sale_info = {};
    state.countPrescriptionSaleCartItems = 0;     
  }, 
  REMOVE_PRES_SALE_CART_INFO: (state, index) =>{ 
    //console.log(state.cartInfo)
    //state.cartInfo.splice(index, 1);  
    ///const cartItemProduct = JSON.stringify(state.cartInfo[0]);  
    //const itemProduct = JSON.parse(cartItemProduct);
    //var obj = state.cartInfo[0];

    //[index].forEach(index => delete obj[index]);

    //console.log(state.cartInfo[])

    // for (var k in state.cartInfo){     // Loop through the object       
    //   for(var j in state.cartInfo[k]){
    //     if(index == j){
          // console.log(j)
          // console.log(index)
          // console.log(state.cartInfo[k])
          // console.log(state.cartInfo[k])
          //delete state.cartInfo[k];
    //     }
    //   } 
    // }   
    //for(var i in index) {
       
      // console.log('index',i)
      // console.log('cartItemProduct',cartItemProduct.i)
      // console.log('itemProduct',itemProduct.i)
      // console.log('cartInfo-0',state.cartInfo[0][i])
      // console.log('cartInfo',state.cartInfo.i)
      // delete itemProduct.i; 
    //}
    // console.log('REMOVE_CART_INFO',index)
    // console.log('REMOVE_CART_INFO===',itemProduct.order_discount)
   
    //delete itemProduct.index; 
    //delete itemProduct[index]; 
    //state.cartInfo[0].splice(index, 1); 
  },
  REMOVE_PRES_SALE_CART_ITEMS: (state, index) =>{
    state.prescriptionSaleCartItems.splice(index, 1);  
  }, 
  UPDATE_HOLD_PRES_SALE: (state, payload) => {
    const proxyToObject = Object.assign({}, payload);  
    if( Object.keys(proxyToObject).length > 0){
      state.hold_prescription_sale_info = proxyToObject;
    }else{
      state.hold_prescription_sale_info = {};
    } 
  }
}

const actions = { 
  addPresSaleCartItem ({ commit }, cartItem) {   
    commit('UPDATE_PRES_SALE_CART_ITEMS', cartItem); 
    toast.success("Added to the cart!",{ 
          timeout: 800 
          });     
  },
  addPresSaleHoldItem ({ commit }, cartItem) {   
    commit('UPDATE_PRES_SALE_HOLD_ITEMS', cartItem);     
  },
  addHoldPresSale({ commit }, cartItem) {   
    commit('UPDATE_HOLD_PRES_SALE', cartItem); 
    //toast.success("Successfully added product to the cart!");     
  },
  selectPresSaleCartInfo ({ commit }, infoData) {   
    commit('SELECT_PRES_SALE_CARTINFO', infoData);      
  },
  removePresSaleCartItem ({ commit },  index) {    
    commit('REMOVE_PRES_SALE_CART_ITEMS', index) 
  },
  removePresSaleCartInfo ({ commit },  index) {    
    commit('REMOVE_PRES_SALE_CART_INFO', index) 
  },
  removePresSaleAllCartItems ({ commit }) {
    commit('removePresSaleAllFromcart', '')
  }
}

const getters = { 
  presSaleId: state => state.prescription_sale_id,
  presCartItems: state => state.prescriptionSaleCartItems,
  presCartInfo: state => state.prescriptionSaleCartInfo,
  holdPresSaleInfo: state => state.hold_prescription_sale_info,
  presCartTotal: state => {
    return state.prescriptionSaleCartItems.reduce((acc, cartItem) => {
      return (cartItem.quantity * cartItem.price) + acc;
    }, 0).toFixed(2);
  },
  presCartQuantity: state => {
    return state.prescriptionSaleCartItems.reduce((acc, cartItem) => {
      return cartItem.quantity + acc;
    }, 0);
  }
} 

const prescriptionSaleCartModule = {
  state,
  mutations,
  actions,
  getters
}
export default prescriptionSaleCartModule;